import React from 'react'
import logoWhite from '../../resources/logo-white.svg'
import $t from 'i18n'
import { SUPPORT_PHONE_NUMBER_WITH_COUNTRY_CODE } from 'consts'

import './Footer.css'

export const Footer = () => {
  return (
    <div className='footer'>
      <div className='footer-top'>
        <div className='footer-links'>
          <img
            data-name={'logo-white'}
            src={logoWhite}
            alt=''
            className='logo-img'
          />
          <div className='footer-details contact'>
            <a
              className='desc footer-text'
              href={`tel:${SUPPORT_PHONE_NUMBER_WITH_COUNTRY_CODE}`}
            >
              {SUPPORT_PHONE_NUMBER_WITH_COUNTRY_CODE}
            </a>
            <a
              className='desc footer-text link'
              href='mailto:support@antidotehealth.com'
            >
              {$t('footer.email')}
            </a>
          </div>
          <hr className='footer-hr show-mobile' />
          <div className='footer-details'>
            <a
              className='desc footer-text'
              href='https://www.antidotehealth.com/legal/terms-of-use'
              target='_blank'
            >
              {$t('footer.terms_of_use')}
            </a>
            <a
              className='desc footer-text'
              href='https://www.antidotehealth.com/insurance/privacy-policy'
              target='_blank'
            >
              {$t('footer.privacy_policy')}
            </a>
          </div>
          <div className='footer-details'>
            <a
              className='desc footer-text'
              href='https://www.antidotehealth.com/insurance/interpreter-services'
              target='_blank'
            >
              {$t('footer.interpreter_services')}
            </a>
            <a
              className='desc footer-text'
              href='https://www.antidotehealth.com/insurance/member-rights-and-responsibilities'
              target='_blank'
            >
              {$t('footer.member_rights')}
            </a>
          </div>
        </div>
        <hr className='footer-hr' />
        <div className='footer-disclaimer footer-text'>
          <div className='tiny'>
            {$t('footer.disclaimer_top_1')}
            {$t('footer.disclaimer_top_2')}
            <a
              className='footer-text link'
              href='https://www.healthcare.gov/'
              target='_blank'
            >
              {$t('footer.healthcare_link')}
            </a>
            <span className='tiny'> {$t('footer.disclaimer_top_3')}</span>
          </div>
          <div className='tiny bold'>{$t('footer.disclaimer_bottom')}</div>
        </div>
      </div>
      <div className='footer-copyright'>
        <div className='desc footer-text'>
          {$t('footer.copyright')} <br className='show-mobile' />
          {$t('footer.all_rights_reserved')}
        </div>
      </div>
    </div>
  )
}

export default Footer
